import type { ReadOnlyRibbonControlDefProps } from './RibbonControlDefinitionProps';
import { getRibbonMailboxInfo } from './getRibbonMailboxInfo';
import { isNativeReportingEnabled } from 'owa-reporting';
import { getMailMenuItemShouldShow } from 'owa-mail-filterable-menu-behavior';
import { type MenuItemType } from 'owa-filterable-menu/lib/components/MenuItemType';
import {
    getSelectedTableView,
    tryGetMailboxInfoFromRowKeysOrIdsIfUnifiedInboxOrDefault,
} from 'owa-mail-list-store';

/**
 * The unified inbox mailboxInfo is virtual and can't answer capability questions, so resolve
 * the selection's actual account and check whether it supports "Report phishing".
 *
 * Returns false when the selection spans multiple mailboxes or none can be resolved, so callers
 * fall back to Junk / Not Junk.
 */
export function isReportPhishingSupportedForUnifiedInboxSelection(
    props: ReadOnlyRibbonControlDefProps
): boolean {
    const tableView = getSelectedTableView();
    if (!tableView) {
        return false;
    }

    try {
        const rowMailboxInfo =
            props.itemId?.mailboxInfo ??
            tryGetMailboxInfoFromRowKeysOrIdsIfUnifiedInboxOrDefault(
                getRibbonMailboxInfo(props.mailboxInfo),
                [...tableView.selectedRowKeys.keys()],
                tableView
            );
        // Gate on the resolved per-account mailbox: it must support native reporting and pass
        // the same folder/selection/sender-self/draft checks as the non-unified ribbon path.
        return (
            isNativeReportingEnabled(rowMailboxInfo) &&
            getMailMenuItemShouldShow(25, rowMailboxInfo)
        );
    } catch {
        // Selection spans different mailboxes (or none resolved).
        return false;
    }
}
